import { useDirtyFormBlocker } from '@/hooks/useDirtyFormBlocker';
import { useEscapeKey } from '@/hooks/useEscapeKey';
import { useTrackFormState } from '@/hooks/useTrackFormState';
import { OPEN_LAYER_SELECTOR, RULE_FORM_ID } from '@/modules/rules/constants';

/** Blocks navigation with unsaved changes (including Rename), and closes the panel on Escape unless a menu is open. */
export const useRuleFormGuards = ({
  isDirty,
  onClose,
}: {
  isDirty: boolean;
  onClose: () => void;
}) => {
  useTrackFormState({ isDirty, formId: RULE_FORM_ID });
  // Rename only adds `?mode=rename`, so compare the query string too.
  useDirtyFormBlocker(undefined, { compareSearch: true });
  useEscapeKey(() => {
    if (!document.querySelector(OPEN_LAYER_SELECTOR)) {
      onClose();
    }
  });
};
